export const types = {
    ON_TIME_DELIVERY_REPORT:"ON_TIME_DELIVERY_REPORT",
    ON_TIME_DELIVERY_REPORT_SUCCESS:"ON_TIME_DELIVERY_REPORT_SUCCESS",
    ON_TIME_DELIVERY_REPORT_EXPORT_SUCCESS:"ON_TIME_DELIVERY_REPORT_EXPORT_SUCCESS",
    ON_TIME_DELIVERY_REPORT_EXPORT:"ON_TIME_DELIVERY_REPORT_EXPORT"
}